<template>
  <div class="grid-view">
    <div
      v-show="showMainList"
      class="main-content"
    >
      <search-item
        config-module="231401"
        :reset="true"
        no="1"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
      >
        <template slot="operations">
          <div>
            <el-button type="primary" no="2" @click="toSpecialApproval(null)">{{ $t('CargoMsg.Cargo_SpecialApproval') }}</el-button>
          </div>
        </template>
        <cargo-advance-select
          slot="customCompany"
          slot-scope="{ item, getValueFromChild }"
          :select-type="TYPE_NAMES.basic_data_Company"
          :clear-not-match="true"
          filterable
          :callback-params="{ refCode: item.itemName, fieldType: item.fieldType }"
          :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
          :multiple="true"
          :tag-value="item.tagValue !== '' ? item.tagValue : item.subType.tagValue"
          options-width="300px"
          :headers="item.headers || []"
          :fields="item.fields || []"
          :tag-name="item.tagName"
          placeholder=" "
          :static-options="overCreditAccounts"
          @parentCallBack="data=>getValueFromChild(data)"
        />
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="23140100"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          no="3"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="23140100"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
          no="4"
          @pagination="toQuery"
        />
      </div>
    </div>
    <!--信控情况-->
    <credit-info-dialog
      ref="creditInfo"
      :visible="creditInfoVisible"
      :dialog-row-data="creditInfoList"
      no="5"
      @onClose="creditInfoClose"
    />
    <!-- 特批弹框 -->
    <el-dialog
      v-if="specialApproval.visible"
      v-el-drag-dialog
      :visible.sync="specialApproval.visible"
      :title="$t('CargoMsg.Cargo_SpecialApproval')"
      width="400px"
      :close-on-click-modal="false"
      no="6"
    >
      <el-form label-width="100px" label-position="right">
        <el-form-item :label="$t('CargoMsg.Cargo_SpecialApprovalValidUntil')">
          <el-date-picker
            v-model="specialApproval.specialApprovalDate"
            no="specialApprovalDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            style="width: 220px;"
            :picker-options="pickerOptions"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" style="display: flex;">
        <div style="align-items: center;display: flex;">
          <span>{{ $t('CargoMsg.Cargo_SpecialApprovalTip') }}</span>
        </div>
        <div style="flex-grow: 1;" />
        <el-button type="primary" no="7" @click="confirmSpecialApproval">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="8" @click="specialApproval.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CreditInfoDialog from '@/views/cargo/v0/Sales/components/CreditBusinessManage/creditInfoDialog'
import {
  queryLockList,
  specialApproval,
  queryCreditInfo,
  queryLockOverCreditAccountIds
} from '@/api/sales/creditBusinessManage'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import RouterAndPrintRenderer from '@/components/Cargo/Common/routerAndPrintRenderer'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import moment from 'moment'
import { getFilterCacheList } from '@/utils/basicDataCache'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'TabLock',
  components: {
    searchItem, CreditInfoDialog, cargoAdvanceSelect
  },
  data() {
    return {
      URL,
      TYPE_NAMES,
      creditInfoVisible: false,
      rowData: [],
      creditInfoList: [],
      isAdvancedQuery: false, // 是否为高级查询
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {},
      showDetail: false,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          RouterAndPrintRenderer
        },
        onCellDoubleClicked: event => {
          this.toLook(event.data)
        }
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'JOBLIST',
        data: {
          JOB_UUID: []
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '', width: 60, checkboxSelection: true, colId: 'custom0',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_LockTheBillTime'), field: 'creditControlTime', colId: 'creditControlTime', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        {
          headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', colId: 'jobJobNo', width: 200
        }, { headerName: this.$t('Payment.warehouseNo'), field: 'jobWarehouseNo', colId: 'jobWarehouseNo', width: 200 },
        { headerName: this.$t('Payment.bookingNo'), field: 'bookingNo', colId: 'bookingNo', width: 200 },
        { headerName: this.$t('Payment.SONO'), field: 'jobSoNo', colId: 'jobSoNo', width: 200 },
        { headerName: this.$t('Payment.itemNo'), field: 'jobPoNo', colId: 'jobPoNo', width: 200 },
        {
          headerName: this.$t('SeaExport.DateOfArrival'), field: 'jobEta', colId: 'jobEta', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.DateOfDeparture'), field: 'jobEtd', colId: 'jobEtd', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.mbl'), field: 'jobMbl', colId: 'jobMbl', width: 200 },
        { headerName: this.$t('Payment.separateNumber'), field: 'jobHbl', colId: 'jobHbl', width: 200 },
        {
          headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'jobOverseaOp', colId: 'jobOverseaOp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', colId: 'jobCustomerId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.NominatedAgent'), field: 'jobDesignationAgent', colId: 'jobDesignationAgent', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.solicitationType'), field: 'jobCargoSource', colId: 'jobCargoSource', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Payment.carrier'), field: 'jobCarrierId', colId: 'jobCarrierId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.businessType'), field: 'jobLob', colId: 'jobLob', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', colId: 'jobBusinessDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.customJobType'), field: 'jobCustomJobType', colId: 'jobCustomJobType', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'name')
          }
        },
        { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVessel', colId: 'jobVessel', width: 200 },
        {
          headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', colId: 'jobLoadingPortCode', width: 200,
          cellRenderer: (params) => {
            if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('Payment.portOfDestination'), field: 'jobDestinationPortCode', colId: 'jobDestinationPortCode', width: 200,
          cellRenderer: (params) => {
            if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('SeaExport.departureStation'), field: 'jobDepartureStation', colId: 'jobDepartureStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.destinationStation'), field: 'jobDestinationStation', colId: 'jobDestinationStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.transitStation'), field: 'jobTransitStation', colId: 'jobTransitStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('Payment.destinationAgent'), field: 'jobDestinationAgent', colId: 'jobDestinationAgent', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.operation'), field: 'jobOp', colId: 'jobOp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.sales'), field: 'jobSales', colId: 'jobSales', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.customerService'), field: 'jobCsr', colId: 'jobCsr', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.Documents'), field: 'jobDc', colId: 'jobDc', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Payment.businessReferenceNumber'), field: 'jobCustomerRefNo', colId: 'jobCustomerRefNo', width: 200 },
        { headerName: this.$t('Payment.relatedJob'), field: 'jobRelatedJob', colId: 'jobRelatedJob', width: 200 },
        { headerName: this.$t('Payment.trustFromJob'), field: 'jobTrustFromJob', colId: 'jobTrustFromJob', width: 200 },
        {
          headerName: this.$t('Payment.planner'), field: 'jobPlanner', colId: 'jobPlanner', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.accrued'), field: 'jobProvisioned', colId: 'jobProvisioned', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Payment.businessStatus'), field: 'jobJobState', colId: 'jobJobState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobStateLabelFunc(params.value)
          },
          hide: true
        },
        { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', colId: 'jobUserDefinedField1', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', colId: 'jobUserDefinedField2', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', colId: 'jobUserDefinedField3', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'jobUserDefinedField4', colId: 'jobUserDefinedField4', width: 200, hide: true },
        {
          headerName: this.$t('Invoice.invoice_salesDepartment'), field: 'jobSalesDepartment', colId: 'jobSalesDepartment', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('Sales.OverControllAccountReceivable'),
          field: 'overCreditAccountIds',
          width: 200,
          valueFormatter: params => {
            if (params.value) {
              const vals = params.value.split(',')
              const txts = []
              for (const val of vals) {
                txts.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(val), 'chineseName'))
              }
              return (vals.length > 1 ? `【${vals.length}${this.$t('Sales.Family')}】` : '') + txts.join(',')
            }
            return ''
          },
          hide: true
        }
      ],
      specialApproval: { // 特批弹窗
        visible: false,
        specialApprovalDate: null,
        ids: []
      },
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      },
      overCreditAccounts: []
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.loadOverCreditAccounts()
      this.toQuery()
    }
  },
  mounted() {
    this.loadOverCreditAccounts()
    this.toQuery()
  },
  methods: {
    loadOverCreditAccounts() {
      const loading = getLoading4Cxt(this)
      queryLockOverCreditAccountIds({ branchId: this.$store.getters.currentOfficeId }).then(res => {
        loading.close()
        this.overCreditAccounts = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => res.data.includes(p.cmpIdx))
      }).catch(() => {
        loading.close()
      })
    },
    fetchOrderRequirement() {
      this.fullscreenLoading = getLoading()
      queryLockList(this.filter)
        .then((res) => {
          this.filter.total = Number(res.data.total)
          this.rowData = res.data.list
          this.fullscreenLoading.close()
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryLockList(this.filter).then((res) => this.handleQueryData(res)).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      console.log('----toAdvancedQuery----')
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = this.handleConditionsBeforeQuery(data)
        this.filter.pageNum = 1
      }
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryLockList(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    // 在查询之前，对条件进行预处理
    handleConditionsBeforeQuery(data) {
      if (AdvancedSearchOption.hasField('charge.ACCOUNT_ID', data)) {
        const condition = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', true)
        data.push(condition.formatObj2Json())
      }
      return data
    },
    // 特批
    toSpecialApproval() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error(this.$t('Sales.PleaseASpecialApprovalBusiness'))
        return
      }
      this.specialApproval.ids = selectedRows.map((item) => item.jobUuid)
      this.specialApproval.visible = true
    },
    // 确定特批
    confirmSpecialApproval() {
      const loading = getLoading4Cxt()
      const ids = this.specialApproval.ids
      if (!ids || ids.length === 0) {
        loading.close()
        this.$message.error(this.$t('Sales.PleaseASpecialApprovalBusiness'))
        return
      }
      specialApproval({ jobUuids: ids.join(','), specialApprovalDate: this.specialApproval.specialApprovalDate }).then((res) => {
        this.specialApproval.specialApprovalDate = null
        this.$message.success(this.$t('Sales.SpecialApprovalSuccessful'))
        this.toAdvancedQuery()
      }).finally(() => {
        loading.close()
        this.specialApproval.visible = false
      })
    },
    toLook(data) {
      const param = {
        companyId: data.jobCustomerId,
        designationAgent: data.jobDesignationAgent,
        jobUuid: data.jobUuid
      }
      queryCreditInfo(param).then((res) => {
        this.creditInfoList = res.data
        this.creditInfoVisible = true
      })
    },
    creditInfoClose() {
      this.creditInfoVisible = false
    },
    // 设置不可选日期范围
    disabledDate(currDate) {
      const selectedDate = moment(currDate).format('YYYY-MM-DD')
      const curDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
      return selectedDate <= curDate
    }
  }
}
</script>
